(ns teamoesterreich.admin-mode.crowdtasker.task.task-question-list
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.eventQuestion :as d-eventQuestion]
            [teamoesterreich.admin-mode.crowdtasker.task.question-detail-form :as question-detail-form]
            [teamoesterreich.util.log :as log]
            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
            [reagent-material-ui.icons.add :refer [add]]
            [reagent-material-ui.icons.arrow-upward :refer [arrow-upward]]
            [reagent-material-ui.icons.arrow-downward :refer [arrow-downward]]
            [reagent-material-ui.icons.insert-photo :refer [insert-photo]]
            [reagent-material-ui.icons.radio-button-checked-two-tone :refer [radio-button-checked-two-tone]]
            [reagent-material-ui.icons.check-box-outline-blank-two-tone :refer [check-box-outline-blank-two-tone]]
            [reagent-material-ui.icons.confirmation-number :refer [confirmation-number]]
            [reagent-material-ui.icons.text-fields :refer [text-fields]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.admin-mode.modal.create-with-name-modal :as create-with-name-modal]
            ))


(defn get-max-index [questions]
  (reduce (fn [c e] (max c (js/parseInt (:crowdtaskerQuestion-index (second e))))) 0 questions))

(defn get-question-by-index [questions index]
  (second (first (filter #(= index (js/parseInt (:crowdtaskerQuestion-index (second %)))) questions))))

(defn get-question-by-uuid [questions uuid]
  (second (first (filter #(= uuid (:crowdtaskerQuestion-uuid (second %))) questions))))

(defn >swap-index-upwards [uuid index questions reload-fn]
  (let [index-before (reduce (fn [ic [_ {i2 :crowdtaskerQuestion-index}]]
                               (let [i2 (js/parseInt i2)] (if (and (< i2 index) (> i2 ic)) i2 ic)))
                             1 questions)]
    (when-let [uuid (:crowdtaskerQuestion-uuid  (get-question-by-index questions index-before))]
      (d-eventQuestion/>question-save-index uuid (inc index-before) (fn [])))
    (d-eventQuestion/>question-save-index uuid index-before reload-fn)))

(defn >swap-index-downwards [uuid index questions reload-fn]
  (when-let [uuid (:crowdtaskerQuestion-uuid  (get-question-by-index questions (inc index)))]
    (d-eventQuestion/>question-save-index uuid index (fn [])))
  (d-eventQuestion/>question-save-index uuid (inc index) reload-fn))



(defn question-card [question !open-question questions reload-fn]
  (let [!st (r/atom {})
        !show-delete-popup (r/cursor !st [:show-delete-popup])]
    (fn []
      (let [question-uuid (:crowdtaskerQuestion-uuid question)
            index (js/parseInt (:crowdtaskerQuestion-index question))]
        [mui/card {:style {:margin "3px"} }

         [are-you-sure-modal/are-you-sure-modal !show-delete-popup "Bist du sicher, dass du diese Frage löschen möchtest?" "Löschen"
          #(d-eventQuestion/>question-save question-uuid {:crowdtaskerQuestion-active false} reload-fn)]
         [mui/card-actions
          [mui/icon-button {:onClick #(reset! !open-question question-uuid)} [edit]]
          [mui/icon-button {:onClick #(reset! !show-delete-popup true)} [delete-forever]]
          (when (> index 1)
            [mui/icon-button {:onClick #(>swap-index-upwards question-uuid index questions reload-fn)} [arrow-upward]])
          (when (< index (count questions))
            [mui/icon-button {:onClick #(>swap-index-downwards question-uuid index questions reload-fn)} [arrow-downward]])
          ;[:span index]
          ]
         [mui/card {:style {:display "flex"
                            :flexDirection "row"} }

          [mui/card-content {:style {:flex "1 0 400px"}}
           [mui/typography {:variant "h5"} (str (:crowdtaskerQuestion-question question) " " )]
           (doall (for [answerOption (sort-by :crowdtaskerAnswerOption-index (filter (fn [e] (and (:crowdtaskerAnswerOption-active e) (not= (:crowdtaskerAnswerOption-type e) "radioOption")))
                                                                                     (clojure.walk/keywordize-keys (:crowdtaskerQuestion-answerOption question))))]
                    ^{:key (str "answerOption-" (:crowdtaskerAnswerOption-uuid answerOption))}
                    (r/as-element (case (:crowdtaskerAnswerOption-type answerOption)
                                    "image" [mui/chip {:label (:crowdtaskerAnswerOption-motiv answerOption) :icon (r/as-element [insert-photo]) :style {:margin "3px 3px 3px 3px"}}]
                                    "radio" [mui/chip {:label (:crowdtaskerAnswerOption-text answerOption) :icon (r/as-element [radio-button-checked-two-tone]) :style {:margin "3px 3px 3px 3px"}}]
                                    "checkbox" [mui/chip {:label (:crowdtaskerAnswerOption-text answerOption) :icon (r/as-element [check-box-outline-blank-two-tone]) :style {:margin "3px 3px 3px 3px"}}]
                                    "decimal" [mui/chip {:label (:crowdtaskerAnswerOption-text answerOption) :icon (r/as-element [confirmation-number]) :style {:margin "3px 3px 3px 3px"}}]
                                    "numeric" [mui/chip {:label (:crowdtaskerAnswerOption-text answerOption) :icon (r/as-element [confirmation-number]) :style {:margin "3px 3px 3px 3px"}}]
                                    "text" [mui/chip {:label (:crowdtaskerAnswerOption-hint answerOption) :icon (r/as-element [text-fields]) :style {:margin "3px 3px 3px 3px"}}]
                                    [mui/chip {:label (:crowdtaskerAnswerOption-text answerOption)
                                               :style {:margin "3px 3px 3px 3px"}}]
                                    ))))

           ]]]
        ))))


(defn get-it []
  (let [!st (r/atom {:tab 0})
        !event-task (r/cursor vstate/app-state [:selected-task])
        ;!st-questionnaire (r/cursor vstate/app-state [:edit-crowdtaskerQuestion])
        !open-question (r/cursor vstate/app-state [:edit-crowdtaskerQuestion :open-question])
        !questions (r/cursor vstate/app-state [:edit-crowdtaskerQuestion :questions])
        !loaded (r/cursor vstate/app-state [:edit-crowdtaskerQuestion :questions-loaded])
        reload-fn #(d-eventQuestion/load-task-question-list)
        !show-add-popup (r/cursor !st [:new-question-popup])
        ]
    (fn []

      ;(log/debug "question tab get-it task: " (clj->js @!event-task))

      (if-not @!loaded
        (do
          (d-eventQuestion/load-task-question-list #(reset! !loaded true))
          [mui/card-content {}
           [:br]
           [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
           [mui/typography {} "Lade Daten ... "]
           ]
          )
        (do

          (if @!open-question
            [question-detail-form/question-form !open-question reload-fn]
            (do
              [:div
               ;(log/debug "questions " @!questions)
               [mui/card-content {}
                [mui/grid
                 {:container  true
                  :direction  "row"
                  :alignItems "stretch"
                  :justify    "flex-start"

                  }

                 (doall (for [[uuid question] (sort-by (fn [[uuid n]] (js/parseInt (:crowdtaskerQuestion-index n)))
                                                       (filter (fn [[_ e]] (:crowdtaskerQuestion-active e)) @!questions))]
                          ^{:key (str "question-" uuid)}
                          [mui/grid
                           {:container false
                            :item true
                            :xs 12  ;extra-small: 0px
                            :style {:textAlign "left" :backgroundColor "#e6e6e6"}
                            }
                           [(question-card question !open-question @!questions reload-fn)]
                           ]
                          ))
                 ]
                ]
               [mui/card-actions

                [create-with-name-modal/modal !show-add-popup "Neue Frage hinzufügen" "hinzufügen"
                 (fn [name]
                   (d-eventQuestion/>task-add-new-question (:crowdtaskerTask-uuid @!event-task) name (inc (get-max-index @!questions))
                                                           (fn [q]
                                                             (reload-fn)
                                                             (reset! !open-question (:crowdtaskerQuestion-uuid q))
                                                             ))

                   )]

                [mui/button {:startIcon (r/as-element [add])
                             :variant "outlined"
                             :onClick #(reset! !show-add-popup true)
                             }
                 "Neue Frage hinzufügen"
                 ]

                ]
               ])))

        )
      )))